import type { FC } from "react";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import ButtonBase from "@mui/material/ButtonBase";

import { usePopover } from "src/hooks/use-popover";

import { AccountPopover } from "./account-popover";
import { getInitials } from "src/utils/get-initials";
import useUserDataProvider from "src/contexts/userData-context";

interface AccountButtonProps {
  express?: boolean;
}

export const AccountButton: FC<AccountButtonProps> = ({ express }) => {
  const { userData } = useUserDataProvider();
  const popover = usePopover<HTMLButtonElement>();

  return (
    <>
      <Box
        component={ButtonBase}
        onClick={popover.handleOpen}
        ref={popover.anchorRef}
        sx={{
          alignItems: "center",
          display: "flex",
          borderWidth: 2,
          borderStyle: "solid",
          borderColor: "divider",
          height: 40,
          width: 40,
          borderRadius: "50%",
        }}
      >
        <Avatar
          sx={{
            height: 32,
            width: 32,
          }}
          src={userData?.professional_group_role_user_data?.professional_image || userData?.full_name || ""}
        >
          {getInitials(userData?.full_name)}
        </Avatar>
      </Box>
      <AccountPopover
        anchorEl={popover.anchorRef.current}
        onClose={popover.handleClose}
        open={popover.open}
        express={express}
      />
    </>
  );
};
